import React from 'react';

const PageNotFound = () => <h1>Opps!! page not found</h1>
export default PageNotFound;